(function () {
  function shuffleChildren(container) {
    if (!container) return;

    var items = Array.from(container.children);
    if (items.length < 2) return;

    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var current = items[i];
      items[i] = items[j];
      items[j] = current;
    }

    items.forEach(function (item) {
      container.appendChild(item);
    });
  }

  function refreshSlider(sliderComponent) {
    if (!sliderComponent) return;

    var slider = sliderComponent.querySelector('[id^="Slider-"]');
    if (slider) {
      sliderComponent.slider = slider;
    }

    if (typeof sliderComponent.resetPages === 'function') {
      sliderComponent.resetPages();
      return;
    }

    sliderComponent.sliderItems = sliderComponent.querySelectorAll('[id^="Slide-"]');
    if (typeof sliderComponent.initPages === 'function') {
      sliderComponent.initPages();
    }
  }

  function bindWishlistButtons(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('.wishlist-hero-custom-button').forEach(function (button) {
      document.dispatchEvent(
        new CustomEvent('wishlist-hero-add-to-custom-element', { detail: button })
      );
    });
  }

  function applyRandomOrder(slider) {
    shuffleChildren(slider);
    bindWishlistButtons(slider);
    requestAnimationFrame(function () {
      refreshSlider(slider && slider.closest('slider-component'));
    });
  }

  function loadRecommendations(root) {
    if (root.dataset.loaded === 'true') return;

    var slider = root.querySelector('[id^="Slider-"]');
    var baseUrl = root.dataset.url;
    var sectionId = root.dataset.sectionId;
    var productId = root.dataset.productId;
    if (!slider || !baseUrl || !sectionId || !productId) return;

    if (slider.querySelector('[id^="Slide-"]')) {
      root.dataset.loaded = 'true';
      applyRandomOrder(slider);
      return;
    }

    var url =
      baseUrl +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&section_id=' +
      encodeURIComponent(sectionId);

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations request failed');
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var source =
          doc.querySelector('[data-product-list-inside-recs] [id^="Slider-"]') ||
          doc.querySelector('#Slider-' + sectionId) ||
          doc.querySelector('.product-list-inside__slider');
        var hasSlides = source && source.querySelector('[id^="Slide-"]');

        if (!hasSlides) {
          root.hidden = true;
          return;
        }

        slider.innerHTML = source.innerHTML;
        root.dataset.loaded = 'true';
        root.hidden = false;
        root.removeAttribute('hidden');
        applyRandomOrder(slider);
      })
      .catch(function (error) {
        console.warn('Product list inside recommendations could not load.', error);
        root.hidden = true;
      });
  }

  function observeRecommendations(root) {
    if (!('IntersectionObserver' in window)) {
      loadRecommendations(root);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        if (!entries[0] || !entries[0].isIntersecting) return;
        obs.unobserve(root);
        loadRecommendations(root);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );

    observer.observe(root);
  }

  function initCollectionSliders() {
    document.querySelectorAll('.product-list-inside__slider').forEach(function (slider) {
      if (slider.closest('[data-product-list-inside-recs]')) return;
      applyRandomOrder(slider);
    });
  }

  function init() {
    initCollectionSliders();
    document.querySelectorAll('[data-product-list-inside-recs]').forEach(observeRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
